import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthorizeControlService } from 'pr1-ui-components';

@Component({
  selector: 'app-product-brand-asset-list',
  templateUrl: './product-brand-asset-list.component.html',
  styleUrls: ['./product-brand-asset-list.component.scss']
})
export class ProductBrandAssetListComponent implements OnInit {
  brandId: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authorizationService: AuthorizeControlService
  ) { }

  ngOnInit(): void {
    this.brandId = this.route.snapshot.params['brandId'];
  }

  cancel(): void {
    this.router.navigate([`../../`], { relativeTo: this.route, queryParamsHandling: 'preserve' });
  }

  canEdit(): boolean {
    return this.authorizationService.checkAccess('edit||offermang');
  }

}
